import { SelectOption } from '@globaleris/ui.library'
import { ProfileModel } from '../../api/Argentia/endpoints/profiles/model/profiles'
import { ProfileFormData } from './components/profilesFormDialog'

export const mapFetchTollsToSelectOptions = (tolls: any[]) => {
  return tolls.map(toll => mapFetchTollToSelectOptions(toll))
}

const mapFetchTollToSelectOptions = (toll: any) => {
  return {
    label: toll.description,
    value: toll.id
  }
}

export const mapNewProfileToPostRequest = (formData: ProfileFormData): ProfileModel => {
  return {
    code: formData.code,
    description: formData.description,
    profileType: formData.profileType,
    profileSubtype: formData.profileSubtype,
    commodity: formData.commodity,
    breakdownLevel: formData.breakdownLevel,
    toll: formData.toll
  }
}

export const mapNewProfileToPatchRequest = (formData: ProfileFormData): ProfileModel => {
  return {
    id: formData.id,
    code: formData.code,
    description: formData.description,
    profileType: formData.profileType,
    profileSubtype: formData.profileSubtype,
    commodity: formData.commodity,
    breakdownLevel: formData.breakdownLevel,
    toll: formData.toll
  }
}

export const profileModelToSelectOptions = (profiles: ProfileModel[]): SelectOption[] => {
  return profiles.map(profile => ({
    value: profile.id!,
    label: profile.code!
  }))
}
